module.exports = __webpack_public_path__ + "img/ee0e08d.jpg";